import { Component, OnInit } from '@angular/core';
import {FormControl} from "@angular/forms";

@Component({
  selector: 'ui-datepicker',
  templateUrl: './ui-datepicker.component.html'
})
export class UiDatepickerComponent implements OnInit {

  date: FormControl = new FormControl();
  multipleDate: FormControl = new FormControl();

  constructor() { }

  ngOnInit() {
    setTimeout(() => {
      this.date.setValue(new Date('03.06.2020'));
      // this.date.disable();
    },2000);
  }

  test() {
  }

  multipleTest() {

  }
}
